import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'bxb-no-tenant',
  template: require('./access.denied.component.html'),
  styles: [require('./access.denied.component.scss')]
})

export class AccessDeniedComponent {
  constructor(private router: Router) {}

  onLoginNavigate() {
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/403/access.denied.component.ts